/**
 * Traductions landing-consumer (fr).
 * Remplace react-i18next — pas de dépendance externe requise.
 *
 * Supporte :
 *   - Clés imbriquées : t('landing.thanks-heading')
 *   - Interpolation   : t('landing.lottery-popup-body', { count: 1 })
 *   - Pluriel i18next : t('map.points-count', { count: 3 }) → clé _other/_one
 */

const fr = {
  landing: {
    'thanks-heading': 'MERCI',
    'thanks-subheading': 'pour votre commande\u00a0!',
    'commitment-intro': 'Cette commande a été expédiée dans un emballage conçu pour être réutilisé.',
    'commitment-cta': 'Rendez-le pour que nous puissions expédier une nouvelle commande avec.',
    'lottery-popup-title': "Jeu concours",
    'lottery-popup-body': "Rendez votre emballage, inscrivez-vous et tentez votre chance. Une commande rembours\u00e9e chaque mois\u00a0!",
    'lottery-popup-note': "Inscription \u00e0 la fin du parcours\u00a0\u00ab\u00a0Rendre mon emballage\u00a0\u00bb.",
    'lottery-popup-ok': "J'ai compris\u00a0!",
    'lottery-teaser-sub': 'Tentez de vous faire rembourser votre commande',
    'cta-return-package': 'Rendre mon emballage',
    'cta-separator': 'ou',
    'cta-return-order': 'Renvoyer ma commande',
    'operated-by': 'Opéré par MOBIUSpack',
    'error-invalid-token': 'Vérifiez que vous avez scanné le bon QR code sur votre emballage.',
  },
  tuto: {
    title: 'Comment ça marche\u00a0?',
    'slide-1-title': 'Trouvez un point de collecte',
    'slide-1-body': 'Carte interactive avec les relais partenaires proches de chez vous.',
    'slide-2-title': 'Scannez votre emballage',
    'slide-2-body': 'Pointez votre caméra sur le QR code imprimé sur l\u2019emballage MOBIUS.',
    'slide-3-title': 'Déposez-le',
    'slide-3-body': 'Présentez le code-barres généré au point relais, et c\u2019est fait\u00a0!',
    'slide-4-title': 'Tentez votre chance',
    'slide-4-body': 'Inscrivez-vous au jeu concours pour vous faire rembourser votre commande.',
    'cta-next': 'Suivant',
    'cta-start': "C'est parti",
  },
  map: {
    'search-placeholder': 'Rechercher une adresse\u2026',
    'filter-all': 'Tous',
    'filter-mobiuspack': 'MOBIUSpack',
    'filter-relay': 'Relais',
    'filter-locker': 'Locker',
    'filter-post': 'La Poste',
    'status-open': 'OUVERT',
    'status-closed': 'FERMÉ',
    'hours-title': 'Horaires',
    'action-more': "+ d'infos",
    'action-less': 'Réduire',
    'action-go': 'Y aller',
    'action-select': 'Choisir ce point',
    'locate-me': 'Me localiser',
    'toggle-list': 'Voir la liste',
    'empty-title': 'Aucun point à proximité',
    'empty-body': "Essayez d'élargir la zone ou de chercher une autre adresse.",
    'error-fetch': 'Impossible de charger les points de collecte. Réessayez dans un instant.',
    'distance-km': '{{km}}\u00a0km',
    'points-count_one': '{{count}} point à proximité',
    'points-count_other': '{{count}} points à proximité',
  },
  scan: {
    title: 'Scanner mon colis',
    'instruction-primary': 'Pointez vers le QR code',
    'instruction-secondary': 'Imprimé sur votre emballage MOBIUSpack',
    'manual-cta': 'Saisir le code manuellement',
    'manual-placeholder': 'Ex\u00a0: MP04ZE5C',
    'manual-submit': 'Valider',
    'camera-error': "Impossible d'accéder à la caméra. Utilisez la saisie manuelle.",
    'retry-cta': 'Réessayer',
    'camera-activate-cta': 'Activer la caméra',
    'error-label': 'QR code non reconnu',
    simulate: 'Simuler un scan (dev)',
  },
  deposit: {
    title: 'Rendre mon emballage',
    'package-identified-label': 'Colis identifié',
    'package-identified-value': 'Emballage réemployable',
    'package-not-found': 'non trouvé',
    'no-parcel-message': 'Aucun emballage trouvé. Veuillez rescanner votre emballage.',
    'no-parcel-cta': 'Rescanner mon emballage',
    'barcode-label': 'Code de dépôt',
    'done-cta': "J'ai rendu l'emballage",
    'step-1-title': 'Présentez ce code de dépôt au point relais',
    'step-1-body': 'Le commerçant le scanne pour enregistrer votre retour d\'emballage.',
    'step-2-title': 'Laissez l\u2019emballage sur place',
    'step-2-body': 'Pas besoin de le conditionner, il part tel quel.',
    'step-3-title': "C'est terminé",
    'step-3-body': 'Revenez ici pour confirmer et tenter votre chance au tirage.',
    'more-info-link': "Voir l'explication en vidéo",
    'find-map-link': 'Trouver un point de collecte',
    'intro-accroche': 'La ligne d\'arrivée est toute proche ! Montrez ce code et c\'est dans la poche. 🏁',
  },
  sendback: {
    title: 'Comment retourner ma commande\u00a0?',
    'step-1-title': 'Pr\u00e9parez votre retour',
    'step-1-body': 'Remettez les articles dans leur emballage d\u2019origine.',
    'step-2-title': 'Collez l\u2019\u00e9tiquette de retour',
    'step-2-body': 'Imprimez l\u2019\u00e9tiquette fournie par la marque et collez-la sur le colis.',
    'step-3-title': 'D\u00e9posez au point relais',
    'step-3-body': 'Remettez le colis au commer\u00e7ant. Un email de confirmation vous sera envoy\u00e9.',
    'more-info-link': "Voir l'explication en vidéo",
    'no-parcel-message': 'Aucun emballage trouvé. Veuillez rescanner votre emballage.',
    'no-parcel-cta': 'Rescanner mon emballage',
  },
  bravo: {
    'heading-line-1': 'VOUS ÊTES',
    'heading-line-2': 'SUPER\u00a0!',
    subheading: 'Grâce à vous, nous allons pouvoir livrer une autre personne avec ce colis.',
    'impact-label': 'Votre impact',
    'impact-parcel-value': '1 colis',
    'impact-parcel-label': 'réemployé',
    'impact-co2-value': '-{{co2Saved}}',
    'impact-co2-label': 'CO2 vs neuf',
    'impact-water-value': '-{{waterSaved}}',
    'impact-water-label': 'eau économ.',
    'lottery-header': 'CHOSE PROMISE, CHOSE DUE',
    'lottery-intro-1': 'Pour vous remercier d\u2019avoir joué le jeu,',
    'lottery-intro-2': 'MOBIUSpack vous invite à son tirage au sort.',
    'lottery-prize-label': 'À GAGNER',
    'lottery-prize-value': 'le montant de votre commande\u00a0!',
    'lottery-email-instruction': 'Renseignez votre e-mail pour suivre les résultats.',
    'lottery-email-label': 'Votre e-mail',
    'lottery-email-placeholder': 'prenom.nom@email.com',
    'lottery-phone-label': 'Votre téléphone (optionnel)',
    'lottery-phone-placeholder': '06 00 00 00 00',
    'lottery-consent-before': "J'ai lu et j'accepte le ",
    'lottery-consent-link': "règlement du Jeu Concours",
    'lottery-consent-after': ' et la politique de confidentialité de MOBIUSpack',
    'lottery-consent-marketing': "J'accepte de recevoir les communications de MOBIUSpack (informations sur les tirages mensuels, nouveautés de l'application, offres commerciales). Je peux retirer ce consentement à tout moment.",
    'lottery-email-error': 'Adresse e-mail invalide',
    'lottery-phone-error': 'Numéro de téléphone invalide',
    'lottery-submit-active': 'Valider ma participation',
    'lottery-submit-inactive': 'Renseignez votre e-mail pour participer',
    'lottery-success-title': 'Inscription confirmée\u00a0!',
    'lottery-success': 'Participation enregistrée, bonne chance\u00a0!',
    'lottery-duplicate-title': 'Déjà inscrit !',
    'lottery-error-duplicate': 'Vous avez déjà participé avec cette commande.',
    'lottery-error-invalid': 'Les informations de votre commande sont incorrectes.',
    'lottery-error-not-found': 'Colis introuvable. Vérifiez votre identifiant.',
    'lottery-error-missing-shipping': "Nous sommes désolés, les informations liées à votre commande n'ont pas été retrouvées avec succès.",
    'lottery-error-missing-parcel': "Emballage non trouvé, veuillez rescanner votre emballage.",
    'no-parcel-message': 'Veuillez scanner ou entrer le code de votre emballage pour accéder à cette page.',
    'no-parcel-cta': 'Scanner mon emballage',
    'lottery-error-generic': 'Une erreur est survenue. Réessayez dans un instant.',
    'lottery-rescan-cta': 'Rescanner mon emballage',
    'open-nps': 'Donner mon avis sur le parcours',
    'restart-cta': "Retour à l'accueil",
  },
  nps: {
    title: 'Comment s\u2019est passée la restitution\u00a0?',
    'scale-label': 'De 0 (très difficile) à 10 (très facile)',
    'scale-min': 'Très difficile',
    'scale-max': 'Très facile',
    'comment-label': 'Un commentaire\u00a0? (optionnel)',
    'comment-placeholder': 'Qu\u2019est-ce qui pourrait être amélioré\u00a0?',
    'submit-active': 'Envoyer mon avis',
    'submit-inactive': 'Sélectionnez une note',
    'thanks-title': 'Merci pour votre retour\u00a0!',
    'thanks-body': 'Votre avis nous aide à améliorer l\u2019expérience MOBIUSpack.',
    close: 'Fermer',
  },
  selectParcel: {
    'reception-title': 'Rendre mon emballage',
    'reception-subtitle': 'Quel emballage avez-vous reçu ?',
    'retour-title': 'Renvoyer ma commande',
    'retour-subtitle': 'Choisissez votre type d’emballage.',
    'cta-tutorial': 'Tutoriel',
  },
  common: {
    back: 'Retour',
    close: 'Fermer',
    retry: 'Réessayer',
    loading: 'Chargement\u2026',
  },
};

function getNestedValue(obj, keyPath) {
  return keyPath.split('.').reduce((o, k) => (o != null ? o[k] : undefined), obj);
}

/**
 * Résout une clé de traduction avec interpolation et gestion du pluriel.
 *
 * @param {string} key  - ex: 'landing.thanks-heading'
 * @param {object} vars - ex: { daysLeft: 12 } ou { count: 3 }
 */
export function t(key, vars) {
  let str;

  if (vars && typeof vars.count === 'number') {
    const pluralKey = vars.count === 1 ? `${key}_one` : `${key}_other`;
    str = getNestedValue(fr, pluralKey) ?? getNestedValue(fr, key);
  } else {
    str = getNestedValue(fr, key);
  }

  if (str == null) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[i18n] clé manquante : "${key}"`);
    }
    return key;
  }

  if (vars) {
    return str.replace(/\{\{(\w+)\}\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : `{{${k}}}`));
  }

  return str;
}

export function useConsumerT() {
  return t;
}
